// extracted by mini-css-extract-plugin
export default {"downloadTemplate":"Z9ZdzQ0cdLBRRF9nHdpM","downloadTemplate-container":"jpkQ2A4i46UYvK0h8_NA","button-container":"Btxr_1HjRknhkDomGikb"};